// extracted by mini-css-extract-plugin
export var checkbox = "_88-0";
export var circle = "_88-3";
export var horizontalContainer = "_88-7";
export var sm = "_88-5";
export var switch0 = "_88-2";
export var switchDisabled = "_88-8";
export var switchEnabled = "_88-1";
export var textSwitchContainer = "_88-9";
export var textSwitchOption = "_88-a";
export var textSwitchOptionSelected = "_88-b";
export var verticalContainer = "_88-6";
export var xs = "_88-4";